import React, { Component } from 'react';
import styles from './styles.module.scss';
import commonStyles from '../../../styles/commonStyles.module.scss';
import ctx from 'classnames';
import { TertiaryButton } from '@clover/web-lib-core/dist/components';
import i18next from 'i18next';

interface ComponentProps {
  numberOfLines?: number;
  body: string;
  useDangerouslySetInnerHTML?: boolean;
  upperCasedButtons?: boolean;
  marginBottom?: number;
}

interface ComponentState {
  expanded: boolean;
  showButton: boolean;
}

const LINE_HEIGHT = 20;
const MAX_NUMBER_OF_LINES_TO_SHOW = 4;

export default class LimitedLinesTextBlock extends Component<ComponentProps, ComponentState> {
  private readonly maxHeight: number;
  private readonly textBlockElement: React.RefObject<HTMLInputElement>;
  private readonly marginBottom: number;

  constructor(props: ComponentProps) {
    super(props);
    this.textBlockElement = React.createRef();
    this.maxHeight = (props.numberOfLines || MAX_NUMBER_OF_LINES_TO_SHOW) * LINE_HEIGHT;
    this.marginBottom = props.marginBottom || 0;
    this.state = {
      expanded: false,
      showButton: false,
    };
    this.handleActionButtonClick = this.handleActionButtonClick.bind(this);
  }

  componentDidMount() {
    const eleHeight = this.textBlockElement.current?.scrollHeight;
    if (eleHeight && eleHeight > this.maxHeight) {
      this.setState(prevState => {
        return {
          showButton: true,
        };
      });
    }
  }

  handleActionButtonClick() {
    let isExpanded = !this.state.expanded;
    if (this.textBlockElement && this.textBlockElement.current) {
      if (isExpanded) this.textBlockElement.current.style.maxHeight = 'none';
      else this.textBlockElement.current.style.maxHeight = `${this.maxHeight}px`;
      this.setState({
        expanded: isExpanded,
      });
    }
  }

  render() {
    return (
      <div className={styles.textBlock} data-testid="textBlock">
        {!this.props.useDangerouslySetInnerHTML ? (
          <span
            className={styles.text}
            ref={this.textBlockElement}
            style={{
              maxHeight: `${this.maxHeight}px`,
              lineHeight: `${LINE_HEIGHT}px`,
              marginBottom: `${!this.state.expanded ? this.marginBottom : 0}em`,
            }}
          >
            {this.props.body}
          </span>
        ) : (
          <p
            dangerouslySetInnerHTML={{
              __html: this.props.body,
            }}
            className={styles.text}
            ref={this.textBlockElement}
            style={{
              maxHeight: `${this.maxHeight}px`,
              lineHeight: `${LINE_HEIGHT}px`,
              marginBottom: `${!this.state.expanded ? this.marginBottom : 0}em`,
            }}
          />
        )}

        {this.state.showButton && (
          <TertiaryButton
            onClick={this.handleActionButtonClick}
            className={ctx(
              commonStyles.appMarketButton,
              commonStyles.linkButton,
              this.state.expanded ? styles.readLessButton : null,
              styles.textBlockButton,
            )}
            style={this.props.upperCasedButtons ? { textTransform: 'uppercase' } : {}}
          >
            {this.state.expanded ? i18next.t('buttons.read_less') : i18next.t('buttons.read_more')}
          </TertiaryButton>
        )}
      </div>
    );
  }
}
